export const h1Style = { fontFamily: 'Arial', fontWeight: '500', fontSize: '34pt' };
export const h2Style = { fontFamily: 'Arial', fontWeight: '500', fontSize: '28pt' };
export const lightBackground1 = '#f2f2f2';
export const lightBackground2 = '#bfbfbf';
export const themeRed = '#EA4D3D';
